<template>
  <div>
    <!--搜索-->
    <div class="cavas">
      <div id="zrenderEl"></div>
    </div>
    <!--列表-->
    <div class="search-wrapper">
      <el-header :height="formHeight" ref="vHeader">
        <el-form
          :inline="true"
          size="mini"
          :model="searchForm"
          label-width="100px"
          ref="searchForm"
        >
          <el-row>
            <el-form-item
              style="float: right; margin-top: -2px; margin-left: 20px"
            >
              <el-link
                type="primary"
                :underline="false"
                @click="onCollapse"
                style="margin-right: 15px"
                v-if="nodeIndex != 7 && (nodeIndex != 6 && activeName == 1)"
                >{{ formHeight == "50px" ? "展开" : "折叠" }}</el-link
              >
              <el-button type="primary" @click="onSearch" class="green-btn" :disabled="!nodeStatus.currentProcessCode"
                >搜索</el-button
              >
              <el-button @click="onReset" class="orange-btn" type="warning" :disabled="!nodeStatus.currentProcessCode">重置</el-button>
            </el-form-item>
            <div v-if="(nodeIndex != 6 && nodeIndex != 7) || activeName == 0">
              <el-form-item label="产品编码:" prop="productCodeQuery">
                <el-input
                  v-model.trim="searchForm.productCodeQuery"
                  placeholder="请输入产品编码"
                ></el-input>
              </el-form-item>
              <el-form-item label="产品名称:" prop="productNameQuery">
                <el-input
                  v-model.trim="searchForm.productNameQuery"
                  placeholder="请输入产品名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="产品型号:" prop="productNameQuery">
                <el-input
                  v-model.trim="searchForm.modelNameQuery"
                  placeholder="请输入产品型号"
                ></el-input>
              </el-form-item>
              <el-form-item label="品类:" prop="categoryQuery">
                <el-select v-model="searchForm.categoryQuery" filterable>
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    v-for="item in categoryData"
                    :label="item"
                    :key="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <span class="form-date-picker">
                <el-form-item label="上市时间:">
                  <el-date-picker
                    v-model="searchForm.upDateStart"
                    type="date"
                    value-format="yyyyMMdd"
                    placeholder="选择日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="至" class="date-picker-middle">
                  <el-date-picker
                    v-model="searchForm.upDateEnd"
                    type="date"
                    value-format="yyyyMMdd"
                    placeholder="选择日期"
                  ></el-date-picker>
                </el-form-item>
              </span>
            </div>
            <div v-else-if="activeName == '1' || nodeIndex == 7">
              <el-form-item label="套件编码:" prop="suitCodeQuery">
                <el-input
                  v-model.trim="searchForm.suitCodeQuery"
                  placeholder="请输入套件编码"
                ></el-input>
              </el-form-item>
              <el-form-item label="套件名称:" prop="suitNameQuery">
                <el-input
                  v-model.trim="searchForm.suitNameQuery"
                  placeholder="请输入套件名称"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="通用件标识:"
                prop="commonFlagQuery"
                v-if="nodeIndex != 7"
              >
                <el-select v-model="searchForm.commonFlagQuery" filterable>
                  <el-option label="全部" value=""></el-option>
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-row>
        </el-form>
      </el-header>
    </div>
    <el-container class="list-wrapper" v-if="nodeIndex != 6">
      <el-main class="table-wrap">
        <div style="margin-bottom: 10px">
          <el-button
            type="primary"
            size="mini"
            class="green-btn"
            @click="visibleShow"
            :disabled="!releaseType"
            v-if="nodeIndex != 7 && nodeStatus.currentProcessCode"
            >处理意见
          </el-button>
          <el-button
            type="primary"
            size="mini"
            class="green-btn"
            @click="exportExcel"
            v-if="nodeStatus.currentProcessCode"
            >导出
          </el-button>
          <el-button
            size="mini"
            class="orange-btn"
            @click="release"
            :disabled="!releaseType"
            type="warning"
            v-if="nodeIndex != 7 && nodeStatus.currentProcessCode"
            >发布
          </el-button>
          <el-button
            size="mini"
            class="orange-btn"
            @click="importExcel"
            :disabled="!releaseType"
            type="warning"
            v-if="nodeIndex != 7 && nodeStatus.currentProcessCode"
            >导入
          </el-button>
          <el-button
            size="mini"
            class="orange-btn"
            @click="journal"
            v-if="nodeIndex != 7"
            >日志
          </el-button>
        </div>
        <el-table
          @select="serlectRow"
          ref="table"
          :height="tableHeight"
          border
          :data="tableData.records"
          @selection-change="handleSelectionChange"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          style="width: 100%"
          v-loading="loading"
          element-loading-text="数据加载中..."
          element-loading-spinner="el-icon-loading"
          :row-key="
            (row) => {
              return row.pagehelperRowId;
            }
          "
        >
          <!-- <el-table-column width="65">
            <template slot-scope="scope">
            </template>
          </el-table-column>-->
          <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true"
            v-if="nodeIndex != 7 && nodeStatus.currentProcessCode"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            :label="item.displayName"
            :fixed="item.freezeType"
            :prop="item.columnName"
            :width="`${nodeIndex == 7 ? '' : item.displayWidth}`"
            v-for="(item, index) in columnData"
            :key="item.columnName + index"
            :align="`${item.fieldType == 'string'? 'left' : 'right' }`"
          >
            <template
              #header
              v-if="item.fieldType == 'string' && item.displayName != '图片'"
            >
              <q-table-header-filter
                :prop="item.columnName"
                :label="item.displayName"
                :useSort="true"
                :filterType="item.fieldType"
                :table="reportName"
                :filterOptions="headerFilterOptions[item.columnName]"
                :getFilterOptions="cheoxList"
                :searchReset="searchReset"
                @confirmFilter="confirmFilter"
                @cheoxList="cheoxList"
              />
            </template>
            <template
              #header
              v-else-if="
                item.fieldType == 'numerical' && item.displayName != '图片'
              "
            >
              <q-table-header-filter
                :prop="item.columnName"
                :label="item.displayName"
                :useSort="true"
                filterType="int"
                :table="reportName"
                :filterOptions="headerFilterOptions[item.columnName]"
                :getFilterOptions="cheoxList"
                :width="item.displayWidth"
                :searchReset="searchReset"
                @confirmFilter="confirmFilter"
                @cheoxList="cheoxList"
              />
              <template v-if="item.displayName.includes('销量')">
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <span class="el-icon-question"></span>
                  <div slot="content">
                    包含京东入仓销量
                  </div>
                </el-tooltip>
              </template>
            </template>
            <template slot-scope="scope">
              <template v-if="item.displayName === '图片'">
                <template v-if="showDetailBtn(scope.row)">
                  <el-link
                    :underline="false"
                    type="primary"
                    @click="showDialog(scope.row, 0)"
                    >查看</el-link
                  >
                </template>
              </template>
              <template v-else-if="item.displayName === '产品编码'">
                <el-link
                  :underline="false"
                  type="primary"
                  @click="packCodeClick(scope.row.productCode)"
                  >{{scope.row[item.columnName]}}</el-link
                >
              </template>
              <span v-else>{{
                scope.row[item.columnName] | cellValFormat
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="auto" style="padding-bottom: 10px">
        <div style="overflow: hidden;">
        <div style="float: left; line-height: 32px; color: #555;">
            <span>{{ updateData.updateContent }}</span>
            <span>{{ updateData.latestUpdateTime }}</span>
          </div>
          <el-pagination
            style="float: right;"
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </el-footer>
    </el-container>
    <div class="list-wrapper" v-else>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="产品" name="0">
          <product
            :tableHeight="tableHeight"
            :queryCriteria.sync="queryCriteria"
            :currentProcessCode="nodeStatus.currentProcessCode"
            :updateData="updateData"
            v-if="activeName == '0'"
            ref="product"
          ></product>
        </el-tab-pane>
        <el-tab-pane label="套件" name="1">
          <kit-page
            :tableHeight="tableHeight"
            :queryCriteria.sync="queryCriteria"
            :currentProcessCode="nodeStatus.currentProcessCode"
            :batchName="batchName"
            :updateData="updateData"
            ref="large"
          ></kit-page>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 视频、图片查看 -->
    <pic-video
      v-model="picVideoVisible"
      :data="rowData"
      :detailType="viewType"
      v-if="picVideoVisible"
    ></pic-video>

    <!--新增/编辑弹框-->
    <el-dialog
      :visible.sync="addDialogVisible"
      :title="title"
      :width="`${visibleType == 1 ? '350px' : '800px'}`"
      @close="closeAddForm"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        label-width="100px"
        style="height: 100px"
        :rules="rules"
        v-if="visibleType == 1"
      >
        <el-form-item label="处理意见：" prop="opinion">
          <el-select v-model="addForm.opinion">
            <el-option label="预退" value="预退"></el-option>
            <el-option label="预退升级" value="预退升级"></el-option>
            <el-option label="保留" value="保留" v-show=" nodeIndex >1 && nodeIndex < 6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：" prop="beizu">
          <el-input v-model.trim="addForm.remark" size="small"></el-input>
        </el-form-item>
      </el-form>
      <el-table
        ref="table"
        max-height="300"
        border
        :data="dialogTableData"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        style="width: 100%"
        v-loading="loading2"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
        v-else-if="visibleType == 2"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          prop="processLogName"
          label="流程名"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="processLogTime"
          label="操作时间"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="operationUserName"
          label="操作人"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="orgName"
          label="部门"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="logStatus"
          label="状态"
        ></el-table-column>
      </el-table>
      <el-table
        ref="table"
        max-height="300"
        border
        :data="dialogTableData"
        :header-cell-style="{ backgroundColor: '#F4F8FB',height: '20px' }"
        :row-style="{height: '20px'}"
        style="width: 100%"
        v-loading="loading2"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
        v-else
      >
        <el-table-column
          :show-overflow-tooltip="true"
          prop="productCode"
          label="产品编码"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="productName"
          label="产品名称"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="style"
          label="风格"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="space"
          label="空间"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="material"
          label="材质"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="color"
          label="颜色"
        ></el-table-column>
      </el-table>
      <div slot="footer" style="text-align: right" v-if="visibleType == 1">
        <el-button @click="closeAddForm">取消</el-button>
        <el-button type="primary" @click="add"> 确认 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import picVideoMxin from "./pic&video.mixin";
import stepMin from "./step.mixin.js";
import kitPage from "./common/kitPage.vue";
import product from "./common/product.vue";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "PreReturnedProducts",
  mixins: [stepMin, picVideoMxin, pagePathMixin],
  components: {
    kitPage,
    product,
  },
  data() {
    return {
      loading: false,
      loading2: false,
      titleName: "",
      showFlag: false,
      searchForm: {
        // upDateStart: moment().startOf("year").format("YYYYMMDD"),
        // upDateEnd: moment().format("YYYYMMDD"),
      },
      rules: {},
      activeName: "1",
      nodeIndex: 0,
      batchId: "",
      requestParam: {},
      formHeight: "50px",
      title: "",
      dialogFormVisible: false,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      model: [],
      maxHeight: "auto",
      nodeStatus: {},
      params: {
        headers: {
          "Content-Type": "application/json;charset=utf-8", // 根据后台的接参数方式前端指定请求头
        },
      },
      rules: {
        opinion: [
          { required: true, message: "请选择处理意见", trigger: "blur" },
        ],
      },
      dialogTableData: [],
      addForm: {},
      columnData: [],
      columnDataExport: [],
      queryCriteria: [],
      searchFormData: [],
      headerFilterOptions: {},
      searchReset: false,
      columnList: [],
      onRemoveSpuIds: [],
      selectSpus: [],
      addDialogVisible: false,
      visibleType: 1,
      pageTure: false,
      categoryData: [],
      releaseType: true,
      batchName: "",
      nodeImgIndex: 0,
      lastQuery: {},
      updateData: {}
    };
  },
  computed: {
    tableHeight() {
      let tableIndexHeight = this.nodeIndex == 6 ? 55 : 0;
      if (this.formHeight === "50px") {
        return window.innerHeight - (355 + tableIndexHeight);
      } else {
        let formHeight =
          (this.$refs["vHeader"] && this.$refs["vHeader"].$el.offsetHeight) ||
          0;
        return window.innerHeight - formHeight - 355 + 50;
      }
    },
    reportName() {
      var reportName = "";
      if (this.nodeIndex == 1) {
        reportName = "PreDelistAttacheReport";
      } else if (this.nodeIndex == 2) {
        reportName = "PreDelistOperateReport";
      } else if (this.nodeIndex == 3) {
        reportName = "PreDelistStoreReport";
      } else if (this.nodeIndex == 4) {
        reportName = "PreDelistOperateManagerReport"
      } else if (this.nodeIndex == 5) {
        reportName = "PreDelisAffirmReport";
      } else if (this.nodeIndex == 7) {
        reportName = "PreDelistProcessSuitReport";
      }
      return reportName;
    },
    exportReportName() {
      var reportName = "";
      if (this.nodeIndex == 1) {
        reportName = "PreDelistAttacheExport";
      } else if (this.nodeIndex == 2) {
        reportName = "PreDelistOperatExport";
      } else if (this.nodeIndex == 3) {
        reportName = "PreDelistStoreExport";
      } else if (this.nodeIndex == 4) {
        reportName = "PreDelistOperateManagerExport"
      } else if (this.nodeIndex == 5) {
        reportName = "PreDelisAffirmExport";
      } else if (this.nodeIndex == 7) {
        reportName = "PreDelistProcessSuitExport";
      }
      return reportName;
    },
    importReportName() {
      var reportName = "";
      var title = "";
      if (this.nodeIndex == 1) {
        reportName = "commerceAttacheImport";
        title = "电商商品专员意见导入";
      } else if (this.nodeIndex == 2) {
        reportName = "categoryOperatingImport";
        title = "品类运营意见导入";
      } else if (this.nodeIndex == 3) {
        reportName = "commerceStoreImport";
        title = "电商店铺意见导入";
      } else if (this.nodeIndex == 4) {
        reportName = "operatingHeadImport";
        title = "运营负责人意见导入";
      } else if (this.nodeIndex == 5) {
        reportName = "certifiedFinalImport";
        title = "最终确认意见导入";
      }
      return { reportName, title };
    },
  },
  watch: {
    $route: {
      handler(val, olv) {
        if (
          olv.path == "/productPreReturn" &&
          (val.query.nodeId !== this.lastQuery.nodeId ||
            val.query.batchId !== this.lastQuery.batchId ||
            val.query.batchName !== this.lastQuery.batchName)
        ) {
          this.nodeImgIndex = val.query.nodeId;
          this.batchId = val.query.batchId;
          this.batchName = val.query.batchName;
          this.queryProcessStatus();
        }

        this.lastQuery = val.query;
      },
      deep: true,
    },
  },
  mounted() {
    this.nodeImgIndex = this.$route.query.nodeId;
    this.batchId = this.$route.query.batchId;
    this.batchName = this.$route.query.batchName;
    // this.zrenderInit();
    this.get_getDataRenewal()
    this.queryProcessStatus();
  },
  methods: {
    serlectRow(i, v) {
      this.model = i;
    },
    columns() {
      let data = [
        {
          paramName: "reportName",
          paramValue: this.reportName,
        },
        {
          paramName: "batchId",
          paramValue: this.batchId,
        },
      ];
      this.$q.productLifeCycle.columnsv3({ data: data }).then((res) => {
        this.columnDataExport = [...res.data.sysColumns]
        this.columnData = res.data.sysColumns.map(v=> {
          return {
            ...v,
            columnName: v.columnName.replace(/\"/g,"") //特殊处理columnName带/"的字段名
          }
        });
        console.log(this.columnData);
      });
    },
    categoryOptions() {
      let data = {
        batchId: this.batchId,
        processCode: this.nodeIndex,
      };
      this.$q.productLifeCycle.categoryOptions({ data: data }).then((res) => {
        this.categoryData = res.data;
      });
    },
    publishStatus() {
      let data = {
        batchId: this.batchId,
        processCode: this.nodeIndex,
      };
      this.$q.productLifeCycle.publishStatus({ data: data }).then((res) => {
        this.releaseType = res.data;
      });
    },
    cheoxList(name, type) {
      this.columnList = [];
      this.columnList = JSON.parse(
        JSON.stringify(this.searchFormData.filterData.queryCriteria)
      );
      let obj = {
        type: "",
        paramValue: "",
        orderBy: "",
        paramName: name,
      };
      this.columnList.forEach((v, index) => {
        if (v && v.paramName == name) {
          delete this.columnList[index];
        }
      });
      this.columnList.push(obj);
      let data = {
        colParam: this.columnList,
        reportName: this.reportName,
      };
      data.colParam = this.columnList.filter((n) => n);
      return this.$q.common.reportGetIndexInfo({ data: data }).then((res) => {
        if (type == "string") {
          this.$set(this.headerFilterOptions, name, res.data.string);
        } else {
          this.$set(this.headerFilterOptions, name, res.data.numerical);
        }
      });
    },
    confirmFilter(filterParam) {
      let that = this;
      let tableName = this.reportName;
      this.common.confirmFilter(that, filterParam, tableName);
    },
    handleClick() {
      this.onSearch()
    },
    onReset() {
      this.$nextTick(_=>{
        this.$refs.table.clearSelection();
      })
      this.searchReset = true;
      this.$store.commit("headerFilters/delHeaderFilter", this.reportName);
      this.tableData.pageNum = 1;
      this.searchForm = {};
      this.queryCriteria = [
        {
          orderBy: "",
          paramName: "batchId", //批次
          paramValue: this.batchId,
          type: "string",
        },
      ];

      if (this.$refs.product && this.activeName == "0") {
        this.$refs.product.onReset(this.queryCriteria);
      } else {
        if (this.$refs.large) this.$refs.large.onReset(this.queryCriteria);
      }
      if (this.nodeIndex == 6) return;
      this.init();
    },
    onSearch(type) {
      this.$nextTick(_=>{
        this.$refs.table.clearSelection();
      })
      this.tableData.pageNum = 1;    
      if(!type) {
        this.$store.commit("headerFilters/delHeaderFilter", this.reportName);
        this.searchReset = true;
      }
      this.queryCriteria = [
        {
          orderBy: "",
          paramName: "batchId", //批次
          paramValue: this.batchId,
          type: "string",
        },
        {
          orderBy: "",
          paramName: "productCodeQuery", //产品编码
          paramValue: this.searchForm.productCodeQuery,
          type: "like",
        },
        {
          orderBy: "",
          paramName: "productNameQuery", //产品名称
          paramValue: this.searchForm.productNameQuery,
          type: "like",
        },
        {
          orderBy: "",
          paramName: "modelNameQuery", //产品型号
          paramValue: this.searchForm.modelNameQuery,
          type: "like",
        },
        {
          orderBy: "",
          paramName: "categoryQuery", //品类
          paramValue: this.searchForm.categoryQuery,
          type: "like",
        },
        {
          orderBy: "",
          paramName: "upDateQuery", //上市时间
          paramValue: this.searchForm.upDateStart
            ? this.searchForm.upDateStart + "," + this.searchForm.upDateEnd
            : "",
          type: "between",
        },
      ];
      if (this.activeName == "1" && this.nodeIndex == 6) {
        this.queryCriteria = [
          {
            orderBy: "",
            paramName: "batchId", //批次
            paramValue: this.batchId,
            type: "string",
          },
          {
            orderBy: "",
            paramName: "suitCodeQuery", //套件编码
            paramValue: this.searchForm.suitCodeQuery,
            type: "like",
          },
          {
            orderBy: "",
            paramName: "suitNameQuery", //套件名称
            paramValue: this.searchForm.suitNameQuery,
            type: "like",
          },
          {
            orderBy: "",
            paramName: "commonFlagQuery", //标识
            paramValue: this.searchForm.commonFlagQuery,
            type: "string",
          },
        ];
      }
      if (this.nodeIndex == 7) {
        this.queryCriteria = [
          {
            orderBy: "",
            paramName: "batchId", //批次
            paramValue: this.batchId,
            type: "string",
          },
          {
            orderBy: "",
            paramName: "suitCodeQuery", //套件编码
            paramValue: this.searchForm.suitCodeQuery,
            type: "like",
          },
          {
            orderBy: "",
            paramName: "suitNameQuery", //套件名称
            paramValue: this.searchForm.suitNameQuery,
            type: "like",
          },
        ];
      }
      if (this.nodeIndex == 6) {
        if (this.activeName == "0" && this.$refs.product) {
          this.$refs.product.onSearch(this.queryCriteria);
        } else {
          if (this.$refs.large) this.$refs.large.onSearch(this.queryCriteria);
        }
      }
      if (this.nodeIndex == 6) return;
      if(type == 1) {
        //处理意见后保留筛选状态及结果
        this.pageTure = true;
        this.init(this.searchFormData)
      }else {
        this.$store.commit("headerFilters/delHeaderFilter", this.reportName);
        this.searchReset = true;
        this.init()
      }
    },
    init(item) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.paramValue);
      let param = {
        filterData: {
          queryCriteria: filter,
          reportName: this.reportName,
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      if (this.pageTure && item) {
        param.filterData = item.filterData;
      }
      this.searchFormData = param;
      this.$q.common
        .reportSearch({ data: JSON.stringify(param) })
        .then((res) => {
          this.tableData = res.data;
          if (null != this.tableData.records) {
            this.loading = false;
          }
          if (res.code == 200) {
            this.loading = false;
            this.pageTure = false;
            this.searchReset = false;
          }
        });
    },
    visibleShow() {
      if (!this.selectSpus.length) {
        this.$message.error("请选择具体的产品编码");
        return;
      }
      this.visibleType = 1;
      this.title = "处理意见";
      this.addDialogVisible = true;
    },
    journal() {
      this.title = "日志";
      this.visibleType = 2;
      this.addDialogVisible = true;
      this.loading2 = true;
      let data = {
        batchNo: this.batchId,
        processCode: this.nodeImgIndex,
      };
      this.$q.productLifeCycle.queryConfirmLog({ data: data }).then((res) => {
        if (res.code == 200) {
          this.dialogTableData = res.data;
          this.loading2 = false;
        }
      });
    },
    packCodeClick(productCode) {
      this.title = "产品详情";
      this.visibleType = 3;
      this.addDialogVisible = true;
      this.loading2 = true;
      let params = {
        params: {
          productCode,
        },
      };
      this.$q.productLifeCycle.productBaseInfo(params).then((res) => {
        if (res.code == 200) {
          this.dialogTableData = [res.data];
          this.loading2 = false;
        }
      });
    },
    add() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        let data = {
          ...this.addForm,
          batchNo: this.batchId,
          processCode: this.nodeIndex,
          chooseProductCode: this.selectSpus.map((v) => v.productCode),
        };
        console.log(data);
        this.$q.productLifeCycle
          .updateOpinionRemark({ data: data })
          .then((res) => {
            if (res.code == 200) {
              this.addDialogVisible = false;
              this.$message.success("新增成功");
              // this.$refs.table.clearSelection();
              this.onSearch(1);
            }
          });
      });
    },
    release() {
      let data = {
        batchId: this.batchId,
        processCode: this.nodeIndex,
      };
      this.$q.productLifeCycle.delistPublish({ data: data }).then((res) => {
        if (res.code == 200) {
          this.$message.success("发布成功");
          this.queryProcessStatus();
          // this.onSearch();
        }
      });
    },
    queryProcessStatus() {
      this.$q.productLifeCycle
        .queryProcessStatus({ fragment: [this.batchId] })
        .then((res) => {
          if (res.code == 200) {
            this.nodeStatus = res.data;
            this.nodeIndex = parseInt(res.data.currentProcessCode);
            console.log(this.nodeIndex);
            this.nodeImgIndex = parseInt(res.data.processCode);
            this.zrenderInit();
            if (this.nodeStatus.currentProcessCode) {
              this.publishStatus();
              this.categoryOptions();
              this.onSearch();
              if (this.nodeIndex != 6) {
                this.columns();
              }
            }
          }
        });
    },
    closeAddForm() {
      this.$nextTick((_) => {
        if (this.$refs["addForm"]) this.$refs["addForm"].clearValidate();
      });
      this.addForm = {};
      this.addDialogVisible = false;
      this.addForm.batchName = "";
    },
    handleSelectionChange(val) {
      this.onRemoveSpuIds = [];
      console.log("val", val);
      val.forEach((x) => {
        this.onRemoveSpuIds.push(x.id);
      });
      this.selectSpus = val;
      console.log(this.selectSpus);
    },
    onCollapse() {
      if (this.formHeight === "50px") {
        this.formHeight = "auto";
      } else {
        this.formHeight = "50px";
      }
      this.tableReload = false;
      this.$nextTick((_) => {
        this.tableReload = true;
      });
    },
    onSearchList() {
      this.tableData.pageSize = 30;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    resetForm() {
      this.initSearchForm();
      this.tableData.pageSize = 30;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    initSearchForm() {
      this.searchForm = {
        suitCode: null,
        suitName: null,
      };
    },
    onSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      this.pageTure = true;
      this.init(this.searchFormData);
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.pageTure = true;
      this.init(this.searchFormData);
    },
    importExcel() {
      this.openSubPage({
        path: "/preReturnedProductsImport",
        query: {
          reportName: this.importReportName.reportName,
          title: this.importReportName.title,
          batchNo: this.batchId,
          batchName: this.batchName
        },
      });
      
    },
    exportExcel() {
      let params = {
        taskDTO: {
          appCode: "ec-pc-new",
          paramMap: this.searchFormData.filterData,
          reportName: this.exportReportName,
        },
        columnDTOs: null,
      };
      let tmp = JSON.parse(JSON.stringify(this.columnDataExport));

      params.columnDTOs = tmp
        .map((item) => {
          return {
            columnName: item.displayName,
            fieldName: item.columnName,
            fieldType: item.fieldType == 'numerical' ? 'integer' : item.fieldType,
            columnFormat: item.columnFormat,
          };
        })
        .filter((v) => v.columnName != "图片");
      this.$q.common
        .customExportExcel({ data: params })
        .then((res) => {
          this.$message({
            type: "success",
            message: "提交下载任务成功，请稍后到导出列表查阅！",
          });
        })
        .catch((err) => {});
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    get_getDataRenewal() {
      this.$q.preSalePlan.getDataRenewal()
      .then(res=>{
        this.updateData = res.data[1];
      })
    }
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
  beforeDestroy() {
    this.$store.commit("headerFilters/delHeaderFilter", this.reportName);
  },
};
</script>

<style lang="stylus" scoped>

>>> .el-table .el-tooltip__popper {
  max-width: 400px !important;
}

.search-wrapper {
  margin: 10px;
  background-color: #ffffff;
  border-radius: 3px;
}

>>> .el-header {
  // margin: 10px;
  padding: 10px;
  overflow: hidden;
}

>>> .el-divider {
  margin: 10px 0;
}

#zrenderEl {
  width: 100%;
  height: 80px;
}

.list-wrapper {
  padding: 10px;
  margin: 10px;
  background-color: #ffffff;
  border-radius: 3px;
}

>>> .el-form-item {
  margin-bottom: 10px;
}

.cavas {
  margin: 10px;
  background-color: #fff;
  border-radius: 3px;
}

.table-wrap {
  padding: 10px;
}

>>> .el-input--small .el-input__inner {
  height: 28px;
  line-height: 28px;
}

>>> .el-input--suffix .el-input__inner {
  height: 28px;
  line-height: 28px;
}

.oneLine {
    overflow: hidden;
    white-space: nowarp;
    text-overflow: ellipsis
}
.content {
    max-width: 300px
}

// >>> .el-table .is-scrolling-left+.el-table__fixed {
//   display: block
// }

</style>

<style lang="css">
  .el-tooltip__popper {
    max-width: 40%;
  }
</style>

